import { Denomination, Sku } from '../../../models/sku.model';
import Script from 'next/script';

type Props = {
  sku: Sku;
};

export const ProductSchemaMarkup = ({ sku }: Props) => {
  function getThemeImage(sku) {
    return sku.themes.length > 0 ? sku.themes?.[0]?.image : '';
  }

  function makeJsonLd(sku: Sku) {
    const priceList = sku.denominations.sort((d1: Denomination, d2: Denomination) => {
      return d1.value > d2.value ? 1 : 0;
    });
    const image = getThemeImage(sku);
    const lowPrice = priceList.length > 0 ? priceList[0].price : 0;
    const highPrice = priceList.length > 0 ? priceList[priceList.length - 1].price : 0;
    const currency = priceList.length > 0 ? priceList[0].priceCurrency : 'AUD';
    return {
      '@context': 'https://schema.org/',
      '@type': 'Product',
      name: sku.displayName,
      image: [image],
      description: sku.description,
      sku: sku.name,
      brand: {
        '@type': 'Brand',
        name: sku.name,
      },
      offers: {
        '@type': 'AggregateOffer',
        lowPrice: lowPrice.toString(),
        highPrice: highPrice.toString(),
        priceCurrency: currency,
        availability: 'https://schema.org/InStock',
        itemCondition: 'https://schema.org/NewCondition',
      },
    };
  }

  const jsonLd = JSON.stringify(makeJsonLd(sku));

  return (
    <Script async id="productSchemaMarkeup" type="application/ld+json" dangerouslySetInnerHTML={{ __html: jsonLd }} />
  );
};
